// API配置
export const API_BASE_URL =  ''

// 请求配置
export const REQUEST_CONFIG = {
    timeout: 10000,
    headers: {
        // 默认不设置 Content-Type，根据请求类型动态设置
    }
}
